"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSlippage = exports.getZeroExSwapQuote = void 0;
const big_js_1 = __importDefault(require("big.js"));
const axios_1 = require("../lib/axios/axios");
const request_helpers_1 = require("../lib/axios/request-helpers");
const types_1 = require("../types");
const zeroExUrlMap = {
    [types_1.Networks.MAINNET]: 'https://api.0x.org/swap/v1/quote',
    [types_1.Networks.ROPSTEN]: 'https://ropsten.api.0x.org/swap/v1/quote',
    [types_1.Networks.GOERLI]: 'https://goerli.api.0x.org/swap/v1/quote',
};
async function getZeroExSwapQuote({ sellAmount, sellToken, buyTokenAddress, slippagePercentage, networkId, }) {
    return (0, axios_1.axiosRequest)({
        method: 'GET',
        url: (0, request_helpers_1.generateQueryPath)(zeroExUrlMap[networkId], {
            affiliateAddress: '0xB03fc94a3c49B3126A4E6523D10b65d82C44729C',
            sellAmount,
            sellToken,
            buyToken: buyTokenAddress,
            slippagePercentage,
        }),
    });
}
exports.getZeroExSwapQuote = getZeroExSwapQuote;
function validateSlippage(slippage) {
    if (slippage) {
        const slippageBig = (0, big_js_1.default)(slippage);
        if (slippageBig.lt(0) || slippageBig.gt(1)) {
            throw Error(`Slippage: ${slippage} is not a valid fraction from 0 to 1`);
        }
    }
}
exports.validateSlippage = validateSlippage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiemVyb0V4LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NsaWVudHMvemVyb0V4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLG9EQUF5QjtBQUV6Qiw4Q0FBa0Q7QUFDbEQsa0VBQWlFO0FBQ2pFLG9DQUdrQjtBQUVsQixNQUFNLFlBQVksR0FBb0M7SUFDcEQsQ0FBQyxnQkFBUSxDQUFDLE9BQU8sQ0FBQyxFQUFFLGtDQUFrQztJQUN0RCxDQUFDLGdCQUFRLENBQUMsT0FBTyxDQUFDLEVBQUUsMENBQTBDO0lBQzlELENBQUMsZ0JBQVEsQ0FBQyxNQUFNLENBQUMsRUFBRSx5Q0FBeUM7Q0FDN0QsQ0FBQztBQUVLLEtBQUssVUFBVSxrQkFBa0IsQ0FBQyxFQUN2QyxVQUFVLEVBQ1YsU0FBUyxFQUNULGVBQWUsRUFDZixrQkFBa0IsRUFDbEIsU0FBUyxHQU9WO0lBQ0MsT0FBTyxJQUFBLG9CQUFZLEVBQUM7UUFDbEIsTUFBTSxFQUFFLEtBQUs7UUFDYixHQUFHLEVBQUUsSUFBQSxtQ0FBaUIsRUFDcEIsWUFBWSxDQUFDLFNBQVMsQ0FBQyxFQUN2QjtZQUNFLGdCQUFnQixFQUFFLDRDQUE0QztZQUM5RCxVQUFVO1lBQ1YsU0FBUztZQUNULFFBQVEsRUFBRSxlQUFlO1lBQ3pCLGtCQUFrQjtTQUNuQixDQUNGO0tBQ0YsQ0FBZ0MsQ0FBQztBQUNwQyxDQUFDO0FBMUJELGdEQTBCQztBQUVELFNBQWdCLGdCQUFnQixDQUFDLFFBQWlCO0lBQ2hELElBQUksUUFBUSxFQUFFO1FBQ1osTUFBTSxXQUFXLEdBQVEsSUFBQSxnQkFBRyxFQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3ZDLElBQUksV0FBVyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxXQUFXLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQzFDLE1BQU0sS0FBSyxDQUFDLGFBQWEsUUFBUSxzQ0FBc0MsQ0FBQyxDQUFDO1NBQzFFO0tBQ0Y7QUFDSCxDQUFDO0FBUEQsNENBT0MifQ==